import { render, staticRenderFns } from "./PaymentFailure.vue?vue&type=template&id=486fdea7&scoped=true"
import script from "./PaymentFailure.vue?vue&type=script&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486fdea7",
  null
  
)

export default component.exports